import React from "react";
import {formatDate, signed} from "../format.js";

export function PnlTooltip({active, payload, label}) {
    if (!active || !payload?.length) return null;
    return (
        <div className="chart-tooltip">
            <div className="chart-tooltip-date">{formatDate(label)}</div>
            {payload.map((entry) => (
                <div className="chart-tooltip-row" key={entry.dataKey}>
                    <span>{entry.name}</span>
                    <strong>{signed(entry.value)}</strong>
                </div>
            ))}
        </div>
    );
}
